var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonthlyBilling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.166,
    height: 19.075,
    viewBox: "0 0 18.166 19.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4765",
    "data-name": "Rectangle 4765",
    width: 18.166,
    height: 19.075,
    fill: "#d13c3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10025",
    "data-name": "Group 10025",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10024",
    "data-name": "Group 10024",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5653",
    "data-name": "Path 5653",
    d: "M16.382,21.264H1.809A1.817,1.817,0,0,1,0,19.427L0,9H18.162l0,10.423a1.815,1.815,0,0,1-1.784,1.838M4.554,13.994a.9.9,0,0,0,.9-.914V12.2a.919.919,0,0,0-.932-.932H3.642a.909.909,0,0,0-.917.92l0,.9a.9.9,0,0,0,.9.9Zm4.982,0a.9.9,0,0,0,.908-.905l0-.9A.92.92,0,0,0,9.5,11.27H8.666a.919.919,0,0,0-.945.924l0,.9A.909.909,0,0,0,8.655,14Zm5.024,0a.889.889,0,0,0,.879-.9l0-.9a.908.908,0,0,0-.917-.921h-.876a.918.918,0,0,0-.932.932v.876a.908.908,0,0,0,.921.917Zm-10.022,5a.909.909,0,0,0,.912-.93v-.876a.908.908,0,0,0-.921-.917h-.9a.9.9,0,0,0-.9.9l0,.9a.909.909,0,0,0,.917.92Zm4.983,0a.91.91,0,0,0,.923-.921v-.9a.91.91,0,0,0-.933-.908H8.655a.91.91,0,0,0-.933.908l0,.9a.92.92,0,0,0,.945.922Zm5.023,0a.9.9,0,0,0,.9-.919l0-.9a.9.9,0,0,0-.9-.9h-.9a.908.908,0,0,0-.921.917v.876a.919.919,0,0,0,.932.932Z",
    transform: "translate(0 -2.188)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5654",
    "data-name": "Path 5654",
    d: "M15.894,2.3l0-.5h.512a1.816,1.816,0,0,1,1.756,1.832v2.71H.006l0-2.71A1.816,1.816,0,0,1,1.8,1.8l.469,0,.005.553A1.785,1.785,0,0,0,4.125,4.068,1.807,1.807,0,0,0,5.9,2.27l0-.47h6.356l0,.514A1.815,1.815,0,0,0,15.894,2.3",
    transform: "translate(0 -0.437)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5655",
    "data-name": "Path 5655",
    d: "M6.011,1.858a.886.886,0,0,1-.95.866A.914.914,0,0,1,4.2,1.79V.935A.914.914,0,0,1,5.061,0,.884.884,0,0,1,6.01.849Z",
    transform: "translate(-1.02 0)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5656",
    "data-name": "Path 5656",
    d: "M19.222,1.773a.918.918,0,0,1-.864.951.883.883,0,0,1-.948-.848V.85A.883.883,0,0,1,18.357,0a.914.914,0,0,1,.864.935Z",
    transform: "translate(-4.232 0)",
    fill: "#d13c3c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyBilling);
export default __webpack_public_path__ + "static/media/monthly_billing.bc216c12a64708b7dcc3f5ee2ac8b2a8.svg";
export { ForwardRef as ReactComponent };